import { defineRouting } from 'next-intl/routing';

export const locales = ['es', 'en', 'fr', 'de', 'it', 'pt'] as const;
export type Locale = (typeof locales)[number];

/** Fallback when nothing better can be detected (see src/middleware.ts). */
export const defaultLocale: Locale = 'en';

/** Stores the visitor's manual choice; it overrides every automatic detection. */
export const LOCALE_COOKIE = 'NEXT_LOCALE';
export const LOCALE_COOKIE_MAX_AGE = 60 * 60 * 24 * 365;

/** Native names for the language switcher. */
export const localeNames: Record<Locale, string> = {
  es: 'Español',
  en: 'English',
  fr: 'Français',
  de: 'Deutsch',
  it: 'Italiano',
  pt: 'Português',
};

/** Open Graph locale per language. */
export const ogLocales: Record<Locale, string> = {
  es: 'es_ES',
  en: 'en_GB',
  fr: 'fr_FR',
  de: 'de_DE',
  it: 'it_IT',
  pt: 'pt_PT',
};

export const routing = defineRouting({
  locales,
  defaultLocale,
  localePrefix: 'always',
  // Detection and the preference cookie are handled by our own middleware
  localeDetection: false,
  localeCookie: false,
  alternateLinks: false,
});
